export default __webpack_public_path__ + "static/media/main-img-2.f929492e.png";